import { z } from 'zod'
import { oc } from '@orpc/contract'

export const lockProgressNoteResponseSchema = z.object({
  documentReferenceId: z.string(),
  provenanceId: z.string().optional(),
  attestedAt: z.string(),
  alreadyLocked: z.boolean(),
})
export type LockProgressNoteResponse = z.infer<typeof lockProgressNoteResponseSchema>

export const visitLockProgressNote = oc
  .route({ method: 'POST', path: '/v2/visits/{encounterId}/lock' })
  .input(
    z.object({
      encounterId: z.string(),
      documentReferenceId: z.string().min(1),
      attested: z.boolean(),
    }),
  )
  .output(lockProgressNoteResponseSchema)
